import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface RevokePersonalAccessTokenByClientIdParams {
    userId: string;
    tokenName: string;
}

export interface RevokePersonalAccessTokenByClientIdResult  extends IResult {
}

export class RevokePersonalAccessTokenByClientIdRequest extends Request<RevokePersonalAccessTokenByClientIdParams, RevokePersonalAccessTokenByClientIdResult> {
  constructor(params: RevokePersonalAccessTokenByClientIdParams) {
    super('revokePersonalAccessTokenByName', params);
  }
}
